import { Location, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VisualCmptBaseComponent } from '../shared/components/visual-cmpt-base.component';
import { EventsService } from '../shared/services/events.service';
import { UserContextService } from '../shared/services/user-context.service';
import { IBusinessFunctionContext } from '../shared/interfaces/models/ibusiness-function-context.model';
import { UiCard } from '../shared/components/ui-card/ui-card';
import { LoadingUiBlockerComponent } from '../shared/components/loading-ui-blocker/loading-ui-blocker.component';
import { BfSelectionService } from '../bf-selection/bf-selection.service';
import { BfIntent } from '../bf-selection/bf-quiz.model';

@Component({
  selector: 'app-select-bf',
  templateUrl: './select-bf.component.html',
  styleUrl: './select-bf.component.scss',
  imports: [UiCard, LoadingUiBlockerComponent, NgClass],
})
export class SelectBFComponent extends VisualCmptBaseComponent {
  openId: number | null = null;
  /** Зачем выбирается БФ. null — старый сценарий (переход в БФ без цели). */
  intent: BfIntent | null = null;
  /** Пришли из квиза, который не смог определить БФ. */
  fromQuiz = false;
  hasQuiz = false;
  searchQuery = '';

  constructor(
    protected events: EventsService,
    public userContextSvc: UserContextService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected location: Location,
    private bfSelectionSvc: BfSelectionService
  ) {
    super(events, router, route, location);
  }

  get filteredBfs(): IBusinessFunctionContext[] {
    const bfs = this.userContextSvc.currentUser?.BusinessFunctionContexts || [];
    const q = this.searchQuery.trim().toLowerCase();
    return q ? bfs.filter((bf) => bf.Title?.toLowerCase().includes(q)) : bfs;
  }

  ngOnInit() {
    super.ngOnInit();
    this.intent = this.bfSelectionSvc.parseIntent(this.route.snapshot.queryParamMap.get('intent'));
    this.fromQuiz = this.route.snapshot.queryParamMap.get('fromQuiz') === '1';
    this.bfSelectionSvc.loadQuiz().subscribe((quiz) => (this.hasQuiz = !!quiz));

    const queryIdStr = this.route.snapshot.queryParamMap.get('id');
    const queryBFlink = this.route.snapshot.params.link;
    const bfcs = this.userContextSvc.currentUser.BusinessFunctionContexts;

    if (queryIdStr) {
      let qId: number = parseInt(queryIdStr);

      if (qId > 0) {
        const bf = bfcs?.find((x) => x.Id == qId);
        if (bf) this.selectBF(bf);
      }
    }
    if (queryBFlink) {
      const bf = bfcs?.find(
        (bf) => bf.ShortLink?.toLowerCase() === queryBFlink.toLowerCase()
      );
      if (bf) this.selectBF(bf);
    }
  }

  selectBF(bfContext: IBusinessFunctionContext) {
    if (this.intent) {
      this.bfSelectionSvc.selectBusinessFunction(bfContext, this.intent, this.locationBack);
      return;
    }

    if (this.userContextSvc.currentUser.SelectedBF?.Id != bfContext.Id) {
      this.bfSelectionSvc.resetIdeasFilters();
    }

    this.userContextSvc.setCurrentBusinessFunction(bfContext);

    this.router.navigate(['/select-orgunit'], { queryParamsHandling: 'preserve' });
  }

  openQuiz() {
    const queryParams: Record<string, string> = { intent: this.intent ?? 'portal', step: 'quiz' };
    if (this.locationBack) queryParams['locationBack'] = this.locationBack;
    this.router.navigate(['/start'], { queryParams });
  }

  onSearch(event: Event) {
    this.searchQuery = (event.target as HTMLInputElement).value;
  }

  toggle(id: number) {
    this.openId = this.openId === id ? null : id;
  }

  getInitials(title = ''): string {
    const words = title.split(/[\s,]+/).filter((w) => /[A-Za-zА-Яа-яЁё]/.test(w));
    // Готовая аббревиатура в названии: "ПБ", "HR"
    const abbr = words.find((w) => /^[A-ZА-ЯЁ]{2,3}$/.test(w));
    if (abbr) return abbr;
    if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
    return (words[0] ?? '').slice(0, 2).toUpperCase();
  }

  getAvatarTone(id: number | string): 'blue' | 'green' {
    const n = String(id)
      .split('')
      .reduce((a, c) => a + c.charCodeAt(0), 0);
    return n % 2 ? 'green' : 'blue';
  }
}
